<template>
  <div>
    <!-- Floating button -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            small
            color="primary"
            class="report-problem-btn"
            @click="dialog = true"
        >
          <v-icon>mdi-email-arrow-right-outline</v-icon>
        </v-btn>
      </template>
      <span>Report a problem</span>
    </v-tooltip>

    <!-- Dialog -->
    <report-problem-dialog
        v-model="dialog"
    />
  </div>
</template>

<script>
import ReportProblemDialog from "./ReportProblemDialog.vue";

export default {
  name: "ReportProblemButton",
  components: { ReportProblemDialog },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped>
.report-problem-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 999;
  opacity: 0.85;
}
.report-problem-btn:hover {
  opacity: 1;
}
</style>
